import React from 'react';
import { useTranslation } from 'react-i18next';

const LoadingSpinner = () => {
  const { t } = useTranslation();

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: '400px' }}
    >
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">{t('loading')}...</span>
        </div>
        <p className="text-muted">{t('loading')}...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
